import { render, staticRenderFns } from "./stocktypes.vue?vue&type=template&id=13bfdaa4&scoped=true"
import script from "./stocktypes.vue?vue&type=script&lang=js"
export * from "./stocktypes.vue?vue&type=script&lang=js"
import style0 from "./stocktypes.vue?vue&type=style&index=0&id=13bfdaa4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13bfdaa4",
  null
  
)

export default component.exports